module.exports = "/assets/81747bf4ca451a1d35f84881f6fc22e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AK.png
// module id = 1198
// module chunks = 0